var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiChefSChoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#e3fb94",
    opacity: 0.5,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1 14.106l1.879 1.889-1.692 1.632a1.299 1.299 0 01-.94.373h-.023c-.352 0-.68-.14-.94-.396a1.323 1.323 0 01.024-1.89zm10.852-9.677a.49.49 0 00-.305-.396.483.483 0 00-.493.093l-9.28 9.047a.459.459 0 00-.14.327c0 .116.047.233.14.326l2.608 2.658c.094.094.212.14.329.14.141 0 .258-.07.329-.163l4.416-4.943c.4-.443.728-.863.987-1.283a8.926 8.926 0 001.41-5.806z",
    fill: "#31544e"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--chef-s-choice-ff61b4a0677ca0038d87a5b283f714d7.svg";
export { SvgIconUiChefSChoice as Component };